import { resolveVisibleNavGroups } from "./resolveNavigation.js";

/**
 * Résout le mode shell GSD selon rôle actif (pattern GolfMAP/PokerPUR).
 * @param {string} activeRole — rôle UI (admin peut basculer vers sensei/student)
 * @param {{ isAuthenticated?: boolean, pathname?: string }} ctx
 * @returns {'public'|'auth'|'admin'|'manager'|'player'}
 */
export function resolveRoleShellMode(activeRole, ctx = {}) {
  const { isAuthenticated = false, pathname = "" } = ctx;
  if (pathname.startsWith("/connexion") || pathname.startsWith("/demande-compte") || pathname.startsWith("/login") || pathname.startsWith("/request-access")) {
    return "auth";
  }
  if (!isAuthenticated || activeRole === "guest") return "public";
  const role = activeRole === "admin" ? "hanshi" : activeRole;
  if (role === "hanshi" || role === "admin") return "admin";
  if (role === "sensei" || role === "manager" || role === "coach") return "manager";
  if (role === "student" || role === "member" || role === "player") return "player";
  return "public";
}

/**
 * @param {'public'|'auth'|'admin'|'manager'|'player'} shellMode
 */
export function shellModeToLayoutVariant(shellMode) {
  if (shellMode === "admin" || shellMode === "manager") return "sidebar";
  return "top-nav";
}

/**
 * Filtre nav publique uniquement.
 * @param {import('./appConfigTypes.js').GsdAppConfig} config
 * @param {string} locale
 */
export function resolvePublicNavGroups(config, locale = "fr") {
  return resolveVisibleNavGroups(config, { role: "guest", isAuthenticated: false, locale }).filter((g) => g.id === "public");
}
